import {queryOptions} from '@tanstack/react-query';
import {fetchCollection} from './fetchCollection';
import {FetchCollectionParams, fetchCollections} from './fetchCollections';
import {fetchCollectionsCount} from './fetchCollectionsCount';

export const collectionQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['collections', {id}],
    queryFn: () => fetchCollection(id),
  });

export const collectionsQueryOptions = (params: FetchCollectionParams) =>
  queryOptions({
    queryKey: ['collections', {params}],
    queryFn: () => fetchCollections(params),
  });

export const collectionsCountQueryOptions = () =>
  queryOptions({
    queryKey: ['collections-count'],
    queryFn: fetchCollectionsCount,
  });
